import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from "@angular/core";

import { environment } from "../../../environments/environment";
import { SaffronRegistryService } from "../_services";

export function provideSaffronRegistry(): EnvironmentProviders {
  return makeEnvironmentProviders([
    SaffronRegistryService,
    provideAppInitializer(() => {
      const saffronRegistry = inject(SaffronRegistryService);
      return saffronRegistry.registerComponents(environment.wijmoLicenseKey);
    }),
  ]);
}
